<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
  <p>{{ mensaje }}</p>
</div>
<div mat-dialog-actions>
  <button id="Process1" mat-button (click)="negativeAnswer()">No</button>
  <button id="Process2" mat-button (click)="positiveAnswer()" cdkFocusInitial>Sí</button>
  <mat-spinner *ngIf="this.loading" [diameter]="20" style="float: right;"></mat-spinner>
</div>
